import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './shell/app-shell.js';
import { RouteGuard } from './session/route-guard.js';
import { LoginPage } from './pages/login-page.js';
import { DashboardPage } from './pages/dashboard-page.js';
import { MaintenancePage } from './pages/maintenance-page.js';
import { UserInspectPage } from './pages/user-inspect-page.js';
import { OrderInspectPage } from './pages/order-inspect-page.js';
import { ProviderHealthPage } from './pages/provider-health-page.js';
import { ProviderControlPlanePage } from './pages/provider-control-plane-page.js';
import { GmxPage } from './pages/gmx/GmxPage.js';
import { RecentActivityPage } from './pages/recent-activity-page.js';
import { ObservabilityPage } from './pages/observability-page.js';
import { FinancialReviewsPage } from './pages/financial-reviews-page.js';
import { DomainPricingPage } from './pages/domain-pricing-page.js';
import { AnnouncementsPage } from './pages/announcements-page.js';
import { ChatInboxPage } from './pages/chat-inbox-page.js';
import { TierConfigPage } from './pages/tier-config-page.js';
import { AlertsPage } from './pages/alerts-page.js';

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RouteGuard>
            <AppShell />
          </RouteGuard>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="maintenance" element={<MaintenancePage />} />
        <Route path="users/:actorId" element={<UserInspectPage />} />
        <Route path="users" element={<UserInspectPage />} />
        <Route path="messages" element={<ChatInboxPage />} />
        <Route path="orders/:orderId" element={<OrderInspectPage />} />
        <Route path="orders" element={<OrderInspectPage />} />
        <Route path="providers/:providerId" element={<ProviderHealthPage />} />
        <Route path="providers" element={<ProviderHealthPage />} />
        <Route path="mailcom-control-plane" element={<ProviderControlPlanePage />} />
        {/* Phase 37 — alias path so /admin/providers/mailcom resolves to the
            same Parent Mailler dashboard. Both the operator-friendly URL and
            the resource-style URL point at one component. */}
        <Route path="providers/mailcom" element={<ProviderControlPlanePage />} />
        {/* D-228 GMX — SAME page stack bound to providerId='gmx'. Operator URL
            (/gmx-control-plane) + resource URL (/providers/gmx) both resolve to
            the gmx-bound wrapper. The route is mounted BEFORE the dynamic
            /providers/:providerId health route below so it is matched exactly;
            react-router ranks the static segment 'gmx' above ':providerId'. */}
        <Route path="gmx-control-plane" element={<GmxPage />} />
        <Route path="providers/gmx" element={<GmxPage />} />
        <Route path="activity" element={<RecentActivityPage />} />
        <Route path="observability" element={<ObservabilityPage />} />
        <Route path="financial-reviews" element={<FinancialReviewsPage />} />
        <Route path="pricing" element={<DomainPricingPage />} />
        <Route path="tier-config" element={<TierConfigPage />} />
        <Route path="announcements" element={<AnnouncementsPage />} />
        <Route path="alerts" element={<AlertsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
